<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Vehicle Departure Board</span><br/>
      <div style="font-style: italic; font-size: 18px; padding-bottom: 15px; margin-left: 90px; margin-right: 10px">this page shows vehicles soon to be dispatched
        <span style="float:right; font-weight: bold; font-size: 18px;"><b-btn size="sm" aria-label="Reload departures" @click="load_data()">Reload</b-btn>&nbsp;&nbsp;<b-btn size="sm" aria-label="Print the board" @click="printPage()"><i class="fa fa-print"></i></b-btn></span>
      </div>
    </div>

    <br/>
    
    <div v-if="summary">
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="visibleFields"
               :current-page="currentPage" :sort-compare="tableSortCompare" :style="'font-size:' + summary.font_size + 'px'" :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-secondary my-2">
            <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
          </div>
        </template>

        <template slot="next_mvmt_driver" slot-scope="row">
          <template v-for="mvmt_driver in row.item.next_mvmt_driver">
            {{mvmt_driver}}
          </template>
        </template>

        <template slot="next_mvmt_time" slot-scope="row">
          {{row.item.next_mvmt_time | formatDateTimeSmall(summary.timezone)}}
        </template>

        <template slot="next_mvmt_id" slot-scope="row">
          {{row.item.next_mvmt_id}}
          <template v-for="(next_mvmt, idx) in row.item.next_mvmt_list || []">
            <br :key="idx"/>{{next_mvmt.next_mvmt_id}}
          </template>
        </template>

        <template slot="next_mvmt_delta" slot-scope="row">
          <span v-if="row.item.next_mvmt_delta" :style="row.item.next_mvmt_delta.indexOf('d') != -1 ? '' : 'color: #b91c1c'">
            {{row.item.next_mvmt_delta}}
          </span>
          <template v-for="(next_mvmt, idx) in row.item.next_mvmt_list || []">
            <br :key="idx"/>{{next_mvmt.next_mvmt_delta}}
          </template>
        </template>

      </b-table>
      <b-row v-if="items.length > perPage">
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <div v-if="loading" class="text-center text-secondary my-2">
        <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
      </div>
      <b-alert v-else-if="load_error" show variant="warning">
        Could not load departures. Try reloading, or contact support if it keeps happening.
        <b-button size="sm" variant="outline-secondary" class="ml-2" @click="load_data()">Reload</b-button>
      </b-alert>
    </div>
  </div>
</template>

<script>

import {get_trip_sheet} from "../networking/apis";
import {mapState} from "vuex";
import moment from 'moment';
import {justDate} from "../helpers/dates";

export default {
  name: 'trip_sheet',
  metaInfo: {
    title: "Departure Board",
    titleTemplate: "%s · Fleet Integrations",
  },
  data() {
    return {
      tenant_id: null,
      details_fromDate: justDate(moment()),
      items: [],
      summary: null,
      loading: true,
      load_error: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 300,
      pages: [],
      fields: [
        { key: 'name', label: 'Vehicle', sortable: true, visible: true, thStyle: { width: "100px" }},
        { key: 'next_mvmt_driver', label: 'Next Driver', sortable: true, visible: true, thStyle: { width: "150px" }},
        { key: 'next_mvmt_id', label: 'Next Booking', sortable: true, visible: true, thStyle: { width: "120px" }},
        { key: 'next_mvmt_time', label:'Next Start', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'next_mvmt_client_ref1', label:'Customer', sortable: true, visible: true, thStyle: { width: "150px" }},
        { key: 'next_mvmt_delta', label:'Departs In', sortable: true, visible: true, thStyle: { width: "100px" }},
        { key: 'current_location', label:'Current Location', sortable: true, visible: true, thStyle: { width: "300px" }},
        { key: 'next_mvmt_pickup', label:'Pickup', sortable: true, visible: true, thStyle: { width: "300px" }},
        { key: 'next_mvmt_destination', label:'Destination', sortable: true, visible: true, thStyle: { width: "300px" }},
      ],
    }
  },
  async created() {
    this.tenant_id = this.user.tenant
    this.fields_all = this.fields
    await this.check_features()
  },
  mounted() {
    // page-scoped print hook: the non-scoped print block below keys off
    // this class so it cannot affect other pages' printouts
    document.body.classList.add('trip-sheet-print')
  },
  beforeDestroy() {
    document.body.classList.remove('trip-sheet-print')
  },
  methods: {
    printPage() {
      window.print();
    },
    tableSortCompare(aRow, bRow, key) {
      if (key == 'next_mvmt_delta') {
        return aRow['next_mvmt_ms'] - bRow['next_mvmt_ms']
      }
      return false;
    },
    async check_features() {
      this.fields = this.fields_all
      this.load_data()
    },
    async load_data() {
      this.loading = true
      try {
        var results = await get_trip_sheet(this.tenant_id, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        const {value: { data = [] } } = results

        this.summary = data.summary
        this.items = data.results
        this.load_error = false

      } catch(e) {
        this.load_error = true
        this.$emit('showAlert', 'Could not load departures. Try reloading, or contact support if it keeps happening.', 'danger', 5000)
      }

      this.loading = false
    },
},
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    visibleFields() {
      var custom_fields = null;

      if (this.summary && this.summary.visible_fields)
        custom_fields = this.summary.visible_fields;

      if (custom_fields != null) {
        let new_fields = []
        for (let visible_field of custom_fields.split(",")) {
          let found_field = this.fields_all.filter(field => visible_field == field.key)
          if (found_field.length > 0) {
            new_fields.push(found_field[0]);
          }
        }
        return new_fields;
      } else
        return this.fields.filter(field => field.visible)
    }
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
  }
}
</script>

<style>
/* print path for the wall board, active only while this page is mounted
   (body class set in mounted/beforeDestroy). unclips the sticky-header
   scroll container and hides the app chrome so the full fleet prints. */
@media print {
  body.trip-sheet-print #navbar,
  body.trip-sheet-print .fa-launcher-root { display: none !important; }
  body.trip-sheet-print .b-table-sticky-header {
    max-height: none !important;
    overflow: visible !important;
  }
}
</style>

